module.exports = __webpack_public_path__ + "static/media/arrow-right.6ef888d0.svg";